import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-and-down" }, "Light", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-and-down" }, "Dark", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-and-down" }, "LTR", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "hidden-sm-and-down" }, "RTL", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: _ctx.settings,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.settings) = $event)),
    location: _ctx.$vuetify.rtl ? 'left' : 'right',
    temporary: "",
    width: "300"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, { flat: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Settings")
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_toolbar_items, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.settings = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("$close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createTextVNode("Theme")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_toggle, {
                    modelValue: _ctx.$vuetify.theme.dark,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$vuetify.theme.dark) = $event)),
                    borderless: "",
                    mandatory: "",
                    group: "",
                    color: "primary",
                    style: {"display":"grid","grid-template-columns":"1fr 1fr"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, { value: false }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(_component_v_icon, { right: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" mdi-weather-sunny ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, { value: true }, {
                        default: _withCtx(() => [
                          _hoisted_2,
                          _createVNode(_component_v_icon, { right: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" mdi-weather-night ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createTextVNode("Direction")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_toggle, {
                    modelValue: _ctx.$vuetify.rtl,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$vuetify.rtl) = $event)),
                    borderless: "",
                    mandatory: "",
                    group: "",
                    color: "primary",
                    style: {"display":"grid","grid-template-columns":"1fr 1fr"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, { value: false }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _createVNode(_component_v_icon, { right: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" mdi-format-textdirection-l-to-r")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, { value: true }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createVNode(_component_v_icon, { right: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" mdi-format-textdirection-r-to-l ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createTextVNode("Validation")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    attach: "",
                    outlined: "",
                    "persistent-hint": "",
                    dense: "",
                    modelValue: _ctx.validationMode,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.validationMode) = $event)),
                    items: _ctx.validationModes
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createTextVNode("Locale (Mostly in basic example)")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    outlined: "",
                    "persistent-hint": "",
                    dense: "",
                    modelValue: _ctx.locale,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.locale) = $event)),
                    items: _ctx.locales
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createTextVNode("Options")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_switch, _mergeProps({
                        modelValue: _ctx.hideRequiredAsterisk,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.hideRequiredAsterisk) = $event)),
                        label: "Hide Required Asterisk"
                      }, props), null, 16, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" If asterisks in labels for required fields should be hidden ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_switch, _mergeProps({
                        modelValue: _ctx.showUnfocusedDescription,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showUnfocusedDescription) = $event)),
                        label: "Show Unfocused Description"
                      }, props), null, 16, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" If input descriptions should hide when not focused ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_switch, _mergeProps({
                        modelValue: _ctx.restrict,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.restrict) = $event)),
                        label: "Restrict"
                      }, props), null, 16, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Whether to restrict the number of characters to maxLength, if specified in the JSON schema ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_switch, _mergeProps({
                        modelValue: _ctx.readonly,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.readonly) = $event)),
                        label: "Read-Only"
                      }, props), null, 16, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" If true, sets all controls to read-only ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_switch, _mergeProps({
                        modelValue: _ctx.collapseNewItems,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.collapseNewItems) = $event)),
                        label: "Collapse new array items"
                      }, props), null, 16, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" If true, new array items are not expanded by default ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_switch, _mergeProps({
                        modelValue: _ctx.hideArraySummaryValidation,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.hideArraySummaryValidation) = $event)),
                        label: "Hide array summary validation"
                      }, props), null, 16, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" If true, the summary of validation errors in arrays is hidden ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_switch, _mergeProps({
                        modelValue: _ctx.initCollapsed,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.initCollapsed) = $event)),
                        label: "Collapse arrays initially"
                      }, props), null, 16, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" If true, arrays are not expanded initially ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { bottom: "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_switch, _mergeProps({
                        modelValue: _ctx.hideAvatar,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.hideAvatar) = $event)),
                        label: "Hide Array Item Avatar"
                      }, props), null, 16, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Whether the array index avatars shall be shown ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Break horizontal layouts")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        outlined: "",
                        "persistent-hint": "",
                        dense: "",
                        modelValue: _ctx.breakHorizontal,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.breakHorizontal) = $event)),
                        items: _ctx.breakHorizontals
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider)
    ]),
    _: 1
  }, 8, ["modelValue", "location"]))
}